import {useEffect} from "react";
import {reaction} from "mobx";
import type {View} from "../../../../data/models/View";
import type {ViewChangeType} from "../../../../data/models/ViewUtils";

export function useUnsavedLayout(selectedView: View, onChangesDetected: (changes: ViewChangeType[]) => void) {
	useEffect(() => {
		if (!selectedView) {
			onChangesDetected([]);
			return;
		}

		//this will re-run whenever observed data inside hasUnsavedChanges changes
		const dispose = reaction(
			() => {
				const typesToCheckChangesFor: ViewChangeType[] = ["columns", "column sorts"];
				return typesToCheckChangesFor.filter((type) => selectedView.hasUnsavedChanges(type));
			},
			(unsavedTypes) => {
				let normalized: ViewChangeType[] = [];

				// if either "columns" OR "column sorts" is unsaved → report as "columns"
				if (unsavedTypes.includes("columns") || unsavedTypes.includes("column sorts")) {
					normalized.push("columns");
				}

				if (selectedView?.id && normalized.length > 0) {
					onChangesDetected(normalized);
				} else {
					onChangesDetected([]);
				}
			},
			{fireImmediately: true}, // make sure it runs once on mount
		);

		return () => dispose();
	}, [selectedView, onChangesDetected]);
}
